import { einvoiceEwaybillActionTypes } from '../../actions/integrations/einvoiceEwaybillActions';

const EinvoiceEwaybillReducers = (state = { }, action) => {
  switch (action.type) {
  case einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.LOADING: {
    const { enableEwaybillLoading } = action;
    return {
      ...state,
      enableEwaybillLoading,
    };
  }
  case einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.SUCCESS: {
    const { enableEwaybill } = action;
    return {
      ...state,
      enableEwaybill,
    };
  }
  case einvoiceEwaybillActionTypes.GEN_EWAY_BILL.LOADING: {
    const { genEwaybillLoading } = action;
    return {
      ...state,
      genEwaybillLoading,
    };
  }
  case einvoiceEwaybillActionTypes.GEN_EWAY_BILL.SUCCESS: {
    const { genEwaybill } = action;
    return {
      ...state,
      genEwaybill,
    };
  }
  case einvoiceEwaybillActionTypes.GET_EWAY_BILLS.LOADING: {
    const { getEwaybillsLoading } = action;
    return {
      ...state,
      getEwaybillsLoading,
    };
  }

  case einvoiceEwaybillActionTypes.GET_EWAY_BILLS.SUCCESS: {
    const { eWaybills } = action;
    return {
      ...state,
      eWaybills,
    };
  }

  case einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.LOADING: {
    const { GSTAuthenticationLoading } = action;
    return {
      ...state,
      GSTAuthenticationLoading,
    };
  }
  case einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.SUCCESS: {
    const { GSTAuthentication } = action;
    return {
      ...state,
      GSTAuthentication,
    };
  }
  case einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.LOADING: {
    const { GSTDeauthenticationLoading } = action;
    return {
      ...state,
      GSTDeauthenticationLoading,
    };
  }
  case einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.SUCCESS: {
    const { GSTDeauthentication } = action;
    return {
      ...state,
      GSTDeauthentication,
    };
  }

  case einvoiceEwaybillActionTypes.PUSH_IRP.LOADING: {
    const { pushIRPLoading } = action;
    return {
      ...state,
      pushIRPLoading,
    };
  }

  case einvoiceEwaybillActionTypes.PUSH_CN_TO_IRP.LOADING: {
    const { pushCnToIRPLoading } = action;
    return {
      ...state,
      pushCnToIRPLoading,
    };
  }

  case einvoiceEwaybillActionTypes.CANCEL_IRP.LOADING: {
    const { cancelIRPLoading } = action;
    return {
      ...state,
      cancelIRPLoading,
    };
  }

  case einvoiceEwaybillActionTypes.CANCEL_EWAY_BILL.LOADING: {
    const { cancelEwaybillLoading } = action;
    return {
      ...state,
      cancelEwaybillLoading,
    };
  }

  case einvoiceEwaybillActionTypes.ADD_TRANSPORTATION.LOADING: {
    const { addTransporterLoading } = action;
    return {
      ...state,
      addTransporterLoading,
    };
  }

  case einvoiceEwaybillActionTypes.EXCLUDE_EWAY_BILLS.LOADING: {
    const { excludeEwayBillsLoading } = action;
    return {
      ...state,
      excludeEwayBillsLoading,
    };
  }

  case einvoiceEwaybillActionTypes.FETCH_EWAY_BILL.LOADING: {
    const { fetchEwayBillLoading } = action;
    return {
      ...state,
      fetchEwayBillLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default EinvoiceEwaybillReducers;
